<template lang="pug">
	extends ../../../prototype/src/pug/layout/section_column_gray
	include ../../../prototype/src/pug/abstracts/mixin.pug

	block main
		.revogacao__wrapper
			.markdown.revogacao__inner
				include:markdown-it ../../../prototype/src/texts/revogacao.md

				ul
					li 
						|Carta de revogação – 
						a(:href="BASE_URL +'download/formulario_revogacao_cpf_atualizado.pdf'") 
							strong e-CPF
					li 
						|Carta de revogação – 
						a(:href="BASE_URL +'download/formulario_revogaca_cnpj_atualizado.pdf'") 
							strong e-CNPJ
	block variables
		- var id = 'revogacao'
</template>

<script>
export default {
	name: "Revogacao",
	components: {
	},
	data: function() {
		return {
			BASE_URL: process.env.BASE_URL
		}
	},
	mounted: function() {
		this.$update_current_page({ id: "suporte" });
	}
}
</script>
